import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { NgxSpeedGraderComponent } from './speed-grader.component';

// TODO - remove when feedbackSession ngx STAB-680
export const ngxSpeedGraderModule = angular.module('ngxSpeedGraderModule', [])
	.directive('ngxSpeedGrader', downgradeComponent({ component: NgxSpeedGraderComponent }))
	.name;
